import visionCallService from "../../services/visionCallService";
import { visionURL } from "../../config/environment";

export const FETCH_USER_BEGIN = "FETCH_USER_BEGIN";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const FETCH_USER_BY_ID_BEGIN = "FETCH_USER_BY_ID_BEGIN";
export const FETCH_USER_BY_ID_SUCCESS = "FETCH_USER_BY_ID_SUCCESS";
export const FETCH_USER_BY_ID_FAILURE = "FETCH_USER_BY_ID_FAILURE";
export const UPDATE_USER_BEGIN = "UPDATE_USER_BEGIN";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const fetchUserBegin = () => ({
  type: FETCH_USER_BEGIN
});

export const fetchUserSuccess = user => ({
  type: FETCH_USER_SUCCESS,
  payload: { user }
});

export const fetchUserFailure = error => ({
  type: FETCH_USER_FAILURE,
  payload: { error }
});

export function fetchUser(params) {
  return dispatch => {
    dispatch(fetchUserBegin());
    return fetchCurrentUser(
      function (user) {
        dispatch(fetchUserSuccess(user));
      },
      function (error) {
        dispatch(fetchUserFailure(error));
      },
      { include: "roles", ...params }
    );
  };
}

export const fetchUserByIdBegin = id => ({
  type: FETCH_USER_BY_ID_BEGIN,
  payload: { id }
});

export const fetchUserByIdSuccess = (id, user) => ({
  type: FETCH_USER_BY_ID_SUCCESS,
  payload: { id, user }
});

export const fetchUserByIdFailure = (id, error) => ({
  type: FETCH_USER_BY_ID_FAILURE,
  payload: { id, error }
});

export function fetchUserById(id, params = {}) {
  return dispatch => {
    dispatch(fetchUserByIdBegin(id));
    return visionCallService.fetchRequest(
      `${visionURL}/learning_center/api/users/${id}`,
      function (user) {
        dispatch(fetchUserByIdSuccess(id, user));
        return user;
      },
      function (error) {
        console.log("fetch user by id failed", error);
        dispatch(fetchUserByIdFailure(id, error));
      },
      params
    );
  };
}

const fetchCurrentUser = (successCallback, errorCallback, params) => {
  visionCallService.fetchRequest(
    `${visionURL}/learning_center/api/users`,
    function (currentUser) {
      localStorage.setItem("policyPartnerUrl", currentUser.policyPartnerUrl);
      successCallback(currentUser);
      return currentUser;
    },
    function (error) {
      console.log("request failed", error);
      errorCallback(error);
    },
    params
  );
};

export const updateUserBegin = () => ({
  type: UPDATE_USER_BEGIN
});

export const updateUserSuccess = () => ({
  type: UPDATE_USER_SUCCESS
});

export const updateUserFailure = error => ({
  type: UPDATE_USER_FAILURE,
  payload: { error }
});

export const updateUserSettings = (userId, params) => {
  return dispatch => {
    dispatch(updateUserBegin());
    return visionCallService.postJsonDataRequest(
      `${visionURL}/learning_center/api/users/${userId}`,
      { id: userId, user: params },
      () => dispatch(updateUserSuccess()),
      error => dispatch(updateUserFailure(error))
    );
  };
};
